import { axiosPost } from 'shared/api/axios'
import { AxiosError } from 'axios'
import { apiUrls } from 'consts'
import displayGenError from 'shared/utils/displayGenError'
import setFormValidationError from 'shared/utils/setFormValidationError'

interface submitFormProps {
  data: any
  setShowOverlay: Function
  setError: Function
}

const submitForm = async (props: submitFormProps) => {
  let response: any = false

  props.setShowOverlay(true)

  const formData = {
    ...props.data,
  }

  response = await axiosPost(
    apiUrls.reportConfig + '/' + apiUrls.actionSave,
    formData,
    (err: AxiosError) => {
      if (err.response!.status === 422) {
        setFormValidationError(err, props.setError)
      } else {
        displayGenError({ setShowOverlay: props.setShowOverlay })
      }
    },
  )
  return response
}

export default submitForm
